/**
 * Trainer screen — redirects to unified Coach Dashboard.
 * Kept as a route for backward compatibility.
 */
import { useEffect } from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { useRouter } from 'expo-router';
import { useTheme } from '@/contexts/ThemeContext';
import { TYPO } from '@/constants/typography';

export default function TrainerScreen() {
  const router = useRouter();
  const { theme } = useTheme();

  useEffect(() => {
    router.replace('/coach-dashboard' as any);
  }, []);

  return (
    <View style={[styles.container, { backgroundColor: theme.colors.background }]}>
      <Text style={[styles.text, { color: theme.colors.textSecondary }]}>
        Opening Coach Dashboard...
      </Text>
    </View>
  );
}

const styles = StyleSheet.create({
  container: { flex: 1, justifyContent: 'center', alignItems: 'center' },
  text: { fontSize: 14, fontFamily: TYPO.body.regular },
});
